export default __webpack_public_path__ + "static/media/icon_skin.48a42311.png";